// extracted by mini-css-extract-plugin
module.exports = {"link":"_1410bfd27b--link--xcHpa","logo":"_1410bfd27b--logo--l1fAW"};